module.exports = __webpack_public_path__ + "media/images/Elliasen Logo PNG-10f9693a.png";